/**
 * @module ol/format
 */
export { default as EsriJSON } from './format/EsriJSON.js';
export { default as GeoJSON } from './format/GeoJSON.js';
export { default as GML } from './format/GML.js';
export { default as GPX } from './format/GPX.js';
export { default as IGC } from './format/IGC.js';
export { default as IIIFInfo } from './format/IIIFInfo.js';
export { default as KML } from './format/KML.js';
export { default as MVT } from './format/MVT.js';
export { default as OWS } from './format/OWS.js';
export { default as Polyline } from './format/Polyline.js';
export { default as TopoJSON } from './format/TopoJSON.js';
export { default as WFS } from './format/WFS.js';
export { default as WKT } from './format/WKT.js';
export { default as WMSCapabilities } from './format/WMSCapabilities.js';
export { default as WMSGetFeatureInfo } from './format/WMSGetFeatureInfo.js';
export { default as WMTSCapabilities } from './format/WMTSCapabilities.js';
//# sourceMappingURL=format.js.map